import store from "@/store";

const files = {
  shademotion5tutorial: {
    en: "files/tutorials/en/ShadeMotion_v5.pdf",
    es: "files/tutorials/es/ShadeMotion_v5.pdf",
    pt: "files/tutorials/pt/ShadeMotion_v5.pdf",
    fr: "files/tutorials/fr/ShadeMotion_v5.pdf",
    de: "files/tutorials/de/ShadeMotion_v5.pdf",
    zh: "files/tutorials/zh/ShadeMotion_v5.pdf"
  },
  shademotion6tutorial: {
    en: "files/tutorials/en/ShadeMotion_v6.pdf",
    es: "files/tutorials/es/ShadeMotion_v6.pdf"
  },
  formulas: "files/articles/Formulas_Matematicas.pdf",
  rawFilePython: "files/scripts/rawfile-python.zip",
  shademotion5installerLinux: "files/installers/Shademotion-linux-x64.zip",
  shademotion5installerMacos: "files/installers/Shademotion-darwin-x64.zip",
  shademotion5installerWindows: "files/installers/Shademotion-win32-x64.zip",
  shademotion5installerWindowsExe: "files/installers/Shademotion-Setup.exe",
  fieldDataTemplate: {
    en: "files/sample/en/Trees_SMv5.xlsx",
    es: "files/sample/es/Árboles_SMv5.xlsx"
  },
  fieldDataTemplateGPS: {
    en: "files/sample/en/TreesGPS_SMv5.xlsx",
    es: "files/sample/es/ÁrbolesGPS_SMv5.xlsx"
  },
  coverVideo: "files/video/shademotion.mp4",
  coverPreview: "files/video/shademotion.jpg",
  appV6: "v6/",
  photoRZamora: "files/photos/randall_zamora.jpg",
  photoJBarrantes: "files/photos/jose_barrantes.jpg",
  photoESomarriba: "files/photos/eduardo_somarriba.jpg",
  photoFQuesada: "files/photos/francisco_quesada.jpg",
  photoMMalek: "files/photos/mathias_malek.jpg",
  photoEVargas: "files/photos/eduardo_vargas.jpg",
  photoFSinclair: "files/photos/fergus_sinclair.jpg"
};

export const LocalizedPaths = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $localized(key) {
          let path = null;

          if (typeof files[key] === "string") {
            path = files[key];
          } else {
            const requestedLocale = store.getters.locale;
            const supportedLocales = Object.keys(files[key]);
            let finalLocale = null;

            if (supportedLocales.includes(requestedLocale)) {
              finalLocale = requestedLocale;
            } else if (supportedLocales.includes("en")) {
              finalLocale = "en";
            } else if (supportedLocales.includes("es")) {
              finalLocale = "es";
            } else {
              finalLocale = supportedLocales[0];
            }

            path = files[key][finalLocale];
          }

          return process.env.BASE_URL + path;
        }
      }
    });
  }
};

// GA4 events (replaces Universal Analytics window.ga)
export const TrackedEvents = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $track(category, action, label) {
          const locale = store.getters.locale;
          const params = {
            event_category: category,
            event_label: `${label} - ${locale}`,
          };

          if (typeof window.gtag === "function") {
            window.gtag("event", action, params);
          } else if (process.env.NODE_ENV !== "production") {
            console.log("Track Event", { action, ...params });
          }
        },
      },
    });
  },
};

/**
 * Sole source of page_view for this SPA (gtag config uses send_page_view: false).
 */
export function trackPageView(route) {
  if (typeof window.gtag !== "function") {
    return;
  }
  const page_path = route?.fullPath
    ? `#${route.fullPath}`
    : `${window.location.pathname}${window.location.hash}`;
  window.gtag("event", "page_view", {
    page_path,
    page_title: document.title,
  });
}
